import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<line x1=\"5.47955\" y1=\"5.12647\" x2=\"16.0862\" y2=\"15.7331\" stroke-width=\"1.5\" />\n<line x1=\"5.65625\" y1=\"15.2028\" x2=\"15.2022\" y2=\"5.65683\" stroke-width=\"1.5\" stroke-linecap=\"square\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol